export default {
  account_required: 'Please enter username',
  password_required: 'Please enter password',
  confirm_password_different: 'Confirm Password is not the same as Password',
  min_length: "Must be 6 characters or above",
  alphanumeric_char: "Only alphanumeric character are accepted",
  list:{
    0: "Your session has expired, please login again.",
    OK: "Tac Code sent successfully", // for tac code
    ok: "Tac Code sent successfully", // for tac code
    CLOSE: "Oops! It looks like there’s a technical issue with your login.Please reach out to our live chat team for more information.",
    close: "Oops! It looks like there’s a technical issue with your login.Please reach out to our live chat team for more information.",
    accountIdRequired: 'Please enter username',
    passwordStrengthError: 'Create your own password. Password must be 6-20 characters and a combination of number(s) and letter(s).',
    session_expired : 'Session Expired',

    app_id_required: "Application ID is required",
    permission_denied: "Permission denied",
    account_id_required: "Username/Account ID is required",
    verification_code_required: "Verification code is required",
    account_not_exists: "Username/Account does not exist",
    account_inactive: "Username/Account is inactive",
    verify_failed: "Verification process failed",
    parent_account_inactive: "Parent account is inactive",
    transfer_id_required: "Transfer ID is required",
    credit_amount_required: "Credit amount is required",
    duplicate_credit_record: "Duplicated credit record",
    member_wallet_not_exists: "Member wallet does not exist",
    debit_amount_required: "Debit amount is required",
    duplicate_debit_record: "Duplicated debit record",
    insufficient_balance: "Available balance is insufficient",
    result_exists: "Result record has existed",
    debit_record_not_found: "Debit record is not found",
    bank_id_required: "Bank ID is required",
    bank_acc_no_required: "Bank account number is required",
    bank_acc_holder_required: "Bank account holder name is required",
    bank_already_setup: "Bank account has already been setup",
    platform_required: "Platform is required",
    parent_not_exists: "Parent does not exist",
    invalid_password: "Password is invalid",
    parent_id_required: "Parent ID is required",
    password_required: "Password is required",
    contact_phone_required: "Contact phone number is required",
    account_exists: "User/Account ID has already existed",
    vip_mode_not_exists: "VIP mode does not exist",
    session_not_exists: "Your session has expired, please login again.",
    ticket_id_required: "Ticket ID is required",
    ref_id_required: "Reference ID is required",
    ticket_not_exists: "Ticket does not exist",
    ticket_processed: "Ticket has already been processed",
    min_deposit_not_met: "Deposit amount must be at least equals to minimum amount",
    ongoing_promotion: "You have an ongoing promotion. Please claim again later",
    invalid_promo_package: "Invalid promotion package",
    promo_min_deposit_not_met: "Deposit amount does not meet promotion minimum",
    claim_promo_only_once_a_day: "Promotion can only be claimed once a day",
    first_deposit_unmet: "Daily first deposit reward has be claimed",
    newbie_unmet: "Newbie deposit reward has been claimed",
    claim_promo_only_once: "Promotion can only be claimed once",
    inner_catch: "Unexpected Error",
    systemError: "System Error",
    deposit_amount_required: "Deposit amount is required",
    target_bank_id_required: "Target bank ID is required",
    target_bank_acc_no_required: "Target bank account number is required",
    target_bank_acc_holder_required: "Target bank account holder name is required",
    deposit_date_required: "Deposit date is required",
    deposit_method_required: "Deposit method is required",
    min_deposit_not_set: "Minimum deposit amount has not been set",
    min_balance_not_set: "Minimum available balance has not been set",
    ibank_account_not_exists: "IBANK88 account does not exist",
    ibank_account_inactive: "IBANK88 account is inactive",
    withdrawal_amount_required: "Withdrawal amount is required",
    min_withdrawal_not_set: "Minimum withdrawal amount has not been set",
    bank_member_not_exists: "Target member bank account not existed",
    promotion_requirement_not_met: "Promotion requirement has not been met",
    invalid_promotion: "Invalid promotion",
    new_password_required: "New password is required",
    multiplier_not_found: "System unable to process your request at the moment, please try again later",
    contact_phone_exists: "This phone has already been registered",
    BLOCK: "Your account has been suspended",
    tac_is_valid: "Your previous tac code still valid",
    tac_expired: "Your tac code has expired. Please request new tac code",
    invalid_tac: "Invalid Tac Code",
    tac_not_validate: "Tac code not validate yet",
    tacCodeRequired: "Please enter Tac Code",
    invalid_referral_code: "Invalid Referral Code",
    exceed_max_withdrawal: "Exceed maximum withdrawal",
    bank_member_inactive: "User Bank is inactive",
    loginFailed: "Fail to login",
    loginSucceed: "Login successfully",
    usernameRequired : "Please enter username",
    passwordRequired : "Please enter password",
    logoutSucceed : "Logout successfully",
    logoutFailed : "Fail to logout",
    requestSucceed: "Request Success",
    requestFailed : "Request failed",
    requestProcessing : "Your request is currently being processed",
    requestDelayed: "Request delay",
    verificationCodeRequired: "Verification TAC Code is required",
    newPasswordRequired: "New Password is required",
    bankIdRequired: "Please select bank",
    bankNameRequired: "Bank Name is required",
    bankAccHolderRequired : "Bank Account Holder's name is required",
    bankAccNoRequired: "Bank Account number is required",
    depositAmountRequired: "Please enter deposit amount",
    dateRequired: "Please choose date",
    bonusIdRequired: "Please choose gift to claim",
    bank_member_exists: "Bank account already registered",
    never_deposited : "You must make at least one deposit before you can transfer money to your friends",
    transferAmountMustGreaterThanEqual5: "Transfer amount must be greater or equal MYR 5",
    invalid_transfer_amount: "Transfer amount must be greater or equal MYR 5",
    // account_not_exists : "account not exists"
    permission_denied : "Receiver account are not from the same website",
    ongoing_promotion : "You are still having ongoing promotion",
    insufficient_balance : "Insufficient Balance",
    transfer_success: "Transfer Successfully",
    sender_id_required: "Sender ID required",
    recipient_id_required: "Recipient ID required",
    tac_validated: "TAC Code is validated. Please request again",
    pending_result_in_game: "Pending result in game",
    accountIdOnlyNumber: "Valid phone number only",
    unfinishgamedetected: "Please finish your free game before proceed to this action",
    duplicate_review: "You already submitted review previously",
    exceed_withdrawal_frequency: "You have exceeded the daily withdrawal limit.(5 times per day)",
    requestTooFrequentAtLeast2Minutes: "Your request is being processed",
    invalidPhoneNumberFormat: "Invalid Phone Number Format",
    gspayUnderMaintenance: "System under maintenance",
    affiliate_not_exists: "Affiliate not exist",
    phoneRequired: 'Please enter phone number',
    couponeCodeRequired: "Coupon code is required",
    coupon_code_required: "Coupon code is required",
    coupon_not_available: "Coupon code is unavailable",
    contact_email_registered: "Email already exists",
    invalidEmailFormat: "Invalid Email Format",
    emailRequired: "Email is required",
    paymentMethodRequired: "Please Choose Payment Method",
    depositMethodRequired: "Please Choose Deposit Method",
    telcoCodeRequired: "Telco Code required",
    reloadPinCodeRequired: "Reload Pin Code required",
    free_credit_detected: "Free Credits Exclusive For EpicWin Games Only",
    temp_unavailable: "Temporary Unavailable",
    attachment_path_required: "Please upload your transaction receipt",

    //new
    amount_required: "Amount is required",
    auth_token_required: "Session token is required",
    bet_id_required: "Bet id is required",
    bonus_unavailable: "Bonus unavailable",
    client_ip_required: "Client ip required",
    first_deposit_not_met: "First Deposit required",
    ftd_required: "First Deposit required",
    game_maintenance: "Currently under maintenance, please try again later",
    gateway_acc_required : "Gateway account required",
    inbox_id_required: "Inbox ID required",
    insufficient_rebate: "Insufficient rebate",
    insufficient_ticket: "Insufficient ticket",
    is_default_required: "default selection required",
    min_withdrawal_not_met: "Minimum withdrawal not met",
    newbie_not_met: "Newbie promotion criteria not met",
    no_changes: "Default Bank remain unchanged",
    promotion_not_available:"Promotion not available",
    ref_no_required: "Reference number required",
    result_id_required: "Result ID required",
    search_id_required: "Search ID required",
    setting_not_set: "Setting not configured",
    tac_required: "Tac code required",
    ticket_count_required: "Ticket amount required",
    vip_not_exists: "Not a VIP member",
    working_date_required: "Working date required",
    working_month_required: "Working month required",
    withdrawal_amount_lte_withhold_amount: "Withdrawal amount less than or equal to withhold amount.",
    providerRequired: "Provider required",
    invalid_contact_email: "Invalid Email",
    invalidUsernameFormat: "Invalid username format",
    affiliate_inactive: "Inactive Affiliate",
    insufficient_token: "Insufficient Token",
    LaunchGameFailed: "Launch Game Failed",
    "System Error": "System Error",
    "Server Busy": "Server Busy",
    "SERVER BUSY": "Server Busy",
    "Not Available": "Not Available",
    undefined: "Please check your connection and try again later",
    disconnect: "Please check your connection and try again later",
    unableToLaunchSlotGameAtTheMoment: "Unable to launch game at the moment",
    launch_fail: "Launch game error, please contact admin",
    playerCreatedError: "Launch game error, please contact admin",
    "Launch Fail": "Launch game error, please contact admin",
    currencyNotSupported : "Currency not supported",
    game_not_supported:"Game is not supported in the bonus you've claimed.",
    pending_deposit: "Pending Deposit",
    "Launch Game Failed" : "Launch Game Failed",
  },
  processing: "Thank you, your transaction is under processing",
  url:{
    mseric1: "http://172.12.5.200:8100/",
    mseric2: "http://172.12.5.200:8101/",
    epicvip: "https://epicwin.vip/",
    epicinfinity: "https://epicwin8.com/",
    epicwin2: "https://epicwin2.com/"
  },
  wrong_site: {
    description: "Your account belongs to ",
    mseric1: "EpicWinVip",
    mseric2: "EpicWin8",
    epicvip: "EpicWinVip",
    epicinfinity: "EpicWin8",
    epicwin2: "EpicWin2"
  },
  wrong_filetype: "Invalid File",

  newpw_required: "Please enter new password",
  newpw_notsame: "New password cannot be the same as current password",

  oldpw_required: "Please enter current password.",

  pw_notmatched: "Confirm password did not match with new password",

  forgot_password_success: "A temporary password has been sent to your phone number via SMS. Please use this password to log in.",
  change_password_success: "Password updated successfully!!",
  add_bank_success: "New Bank Account added successfully!!",

  tac_tooltips: "TAC Code has been sent to your contact number.",
  tac_tooltips1: 'Click "Resend" to get new tac code',
  tac_countdown: "Resend again in {countdown}",

  bank_details_tooltips: "Your withdrawal transaction wil be rejected, if your Bank Account Name is diferent form your registered full name in EpicWin.",
  copy_clipboard: "Link copied",
  
  about_us_1: "<h1>INSTANT WITHDRAWAL</h1><p>Fast processing times with streamlined and transparent processes for making instant withdrawals</p><h1>KEEPING IT REAL</h1><p>EpicWin is all about complete transparency, so everything is totally upfront, fair and simple.</p>",
  about_us_2: "<h1>YOU WIN IT, YOU GOT IT</h1><p>We believe in rewarding those who deserve to be rewarded. That’s why we have lower down total win requirements and give you money every time you play.</p>",
  about_us_3: "<h1>IT’S ALL YOURS</h1><p>We give you control. Your money is YOUR money, take it, play it or do whatever you want with it.<br/>We think the more you play, the more you should get: more fun and more rewards.<br/>Ready for a more playful and fruitful escape from the everyday?</p>",

  promo_1_title: "FREE CREDIT PROMO",
  promo_1a: "<div class='promo-title text-uppercase mb-3 promo-modal-title'>FREE CREDIT RM100</div><div class='package-table'><div class='row title'><div class='col-4'>Free Credit</div><div class='col-4'>Win Requirement</div><div class='col-4'>Withdrawal Amount</div></div><div class='row table-row'><div class='col-4'>100</div><div class='col-4'>500</div><div class='col-4'>10</div></div></div>",
  promo_1b: "<h1>TERMS &amp; CONDITIONS</h1><ul><li>Win Requirement MYR500 & maximum withdrawal MYR10</li><li>Upon withdrawal of the free credits, the win balance will be reset to zero</li><li>Members who claim these free credits will not qualify for any other promotion until successfully reaching the minimum win balance required under this promotion</li><li>The Free Credit promotion is not valid with other promotions. A member's deposit will automatically be forfeited if found to be used to claim multiple promotions.</li></ul></h1>",
  // general: "<h1>GENERAL TERMS &amp; CONDITIONS</h1><ul><li>A player can only withdrawal 5 times per day.</li><li>EpicWin reserves the right to modify or cancel this promotion at any time without prior notice.</li><li>The General Terms & Conditions of EpicWin apply to all promotions.</li></ul>",
  general: "<h1>GENERAL TERMS &amp; CONDITIONS</h1><ul><li>Withdrawal 5 times per day.</li><li>General Terms & Conditions of EpicWin apply.</li></ul>",

  promo_2_title: "REFERRAL BONUS",
  promo_2a: {
    title1: "Criteria",
    title2: "Rewards",
    details1: "Friend Deposit Any Amount",
    details2: "10% Cashback",
    details3: "Referred Friend's 1st Time Deposit(min. RM30)",
    details4: "1 Jackpot Ticket",
    details5: "40 Successful Referral",
    details6: "1 Jackpot Ticket",
    tnc: "TERMS & CONDITIONS",
    tnc_details0: "Withdrawal 5 times per day",
    tnc_details1: "Get 10% rebate up to RM20  for every Referred Friend's deposit.(any amount)",
    tnc_details2: "Invite and refer at least 3 friends. When a referred friend deposits min. RM30, you’ll get 1 Jackpot Ticket as a reward.",
    tnc_details3: "Maximum win for Free Spins is capped at MYR10 (1000 coins)",
    // tnc_details4: "The 10% cashback promotion is subject to win requirement x1 prior to withdrawal.",
  },

  promo_3_title: "WELCOME BONUS",
  promo_3_title_full: "Welcome Bonus - ONE TIME Bonus",
  promo_3a: {
    title1: "Deposit(MYR)",
    title2: "%",
    title3: "Bonus(MYR)",
    title4: "Starting",
    title5: "Winover",
    details0_1: "10",
    details0_2: "100%",
    details0_3: "10",
    details0_4: "20",
    details0_5: "x3",
    details1_1: "30",
    details1_2: "100%",
    details1_3: "30",
    details1_4: "60",
    details1_5: "x2",
    details2_1: "100",
    details2_2: "120%",
    details2_3: "120",
    details2_4: "220",
    details2_5: "x3",
    details3_1: "300",
    details3_2: "150%",
    details3_3: "450",
    details3_4: "750",
    details3_5: "x5",
    details4: "* For welcome bonus 100% deposit RM10 get RM20, please contact livechat to claim",
    tnc: "TERMS & CONDITIONS",
    tnc_details0: "Withdrawal 5 times per day",
    tnc_details1: "Choose only ONE promotion",
    tnc_details2: "Only available ONCE for any member's 1st deposit",
    tnc_details3: "Winover requirement prior to withdraw"
  },

  promo_4_title: "Daily Deposit Bonus",
  promo_4a: "<div class='promo-title text-uppercase mb-3 promo-modal-title'>Daily Deposit Bonus</div><div class='package-table'><div class='row title'><div class='col-2'>Deposit Amount</div><div class='col-2'>Bonus</div><div class='col-2'>Bonus Amount</div><div class='col-2'>Starting Balance</div><div class='col-2'>Withdrawal Amount</div></div><div class='row table-row'><div class='col-2'>10</div><div class='col-2'>20%</div><div class='col-2'>2</div><div class='col-2'>12</div><div class='col-2'>24</div></div><div class='row table-row'><div class='col-2'>30</div><div class='col-2'>10%</div><div class='col-2'>3</div><div class='col-2'>33</div><div class='col-2'>66</div></div><div class='row table-row'><div class='col-2'>50</div><div class='col-2'>10%</div><div class='col-2'>5</div><div class='col-2'>55</div><div class='col-2'>110</div></div><div class='row table-row'><div class='col-2'>100</div><div class='col-2'>10%</div><div class='col-2'>10</div><div class='col-2'>110</div><div class='col-2'>220</div></div><div class='row table-row'><div class='col-2'>200</div><div class='col-2'>10%</div><div class='col-2'>20</div><div class='col-2'>220</div><div class='col-2'>440</div></div><div class='row table-row'><div class='col-2'>300</div><div class='col-2'>10%</div><div class='col-2'>30</div><div class='col-2'>330</div><div class='col-2'>660</div></div></div>",
  promo_4b: "<h1>TERMS &amp; CONDITIONS</h1><ul><li>20% Bonus is a limited offer and can only be claimed by a member ONCE per day (validity is refreshed 12am daily).</li><li>Minimum deposit required is MYR 10 per transaction, there is no maximum daily deposit.</li><li>This promotion is subject to balance win requirement x2 prior to withdrawal.</li></ul>",

  promo_5_title: "NON BONUS DEPOSIT",
  promo_5a:{
    title1: "Deposit",
    title2: "Free Jackpot Tickets",
    // title3: "Withdraw",
    details1_1: "10",
    details1_2: "50",
    details2_1: "100",
    details2_2: "200",
    details3_1: "500",
    details3_2: "1000",
    details4_1: "500",
    details4_2: "10",
    details5_1: "1000",
    details5_2: "13",
    // details6_1: "2000",
    // details6_2: "10 Premium Spin",
    // details7_1: "3000",
    // details7_2: "12 Premium Spin",
    // details8_1: "5000",
    // details8_2: "25 Premium Spin",
    // details9_1: "10000",
    // details9_2: "50 Premium Spin",
    // details3: "MYR 10",
    description1: "Non-Bonus Deposit can only be used in these cases:",
    description1_1: "(i) Balance less than MYR5",
    description1_2: "(ii) Withdrawal",
    description1_3: "(iii) Zero Balance",
    tnc: "TERMS & CONDITIONS",
    tnc_details0: "Withdrawal 5 times per day",
    tnc_details1: "1x turnover requirement prior to withdraw.",
    // tnc_details2: "Upon withdrawal of the free credits, the win balance will be reset to zero.",
    // tnc_details3: "Members who claim these free credits will not qualify for any other promotion until successfully reaching the minimum win balance required under this promotion",
    // tnc_details4: "The Free Credit promotion is not valid with other promotions. A member's deposit will automatically be forfeited if found to be used to claim multiple promotions.",
    // tnc_details5: "1x turnover requirement prior to withdraw."
  },
  promo_5b: "<h1>TERMS &amp; CONDITIONS</h1><ul><li>1x turnover requirement prior to withdraw.</li></ul>",

  player_transfer: "<h1>TERMS &amp; CONDITIONS</h1><ul><li>Both the sender and receiver must be depositing players with EpicWin.</li><li>To transfer money, both the sender and receiver must not have existing promotions.</li><li>Minimum transfer amount: RM5.</li><li>Transfer Fee: RM0.20 per transaction (charged to receiver)</li><li>All invalid/failed transfers will be directly credited back to the sender.</li></ul></h1>",
  promo_6_title: "VIP BONUS",
  promo_6a: "<div class='promo-title text-uppercase mb-3 promo-modal-title'>VIP BONUS</div><div class='package-table'><div class='row title'><div class='col-3'>Deposit Amount</div><div class='col-3'>Bonus Amount</div><div class='col-3'>Starting Balance</div><div class='col-3'>Withdrawal Amount</div></div><div class='row table-row'><div class='col-3'>1000</div><div class='col-3'>1500</div><div class='col-3'>2500</div><div class='col-3'>7500</div></div></div>",
  promo_6b: "<h1>TERMS &amp; CONDITIONS</h1><ul><li>This promotion is only available ONE time for every members</li><li>This promotion is subject to balance win requirement x3 prior to withdrawal</li></ul>"
};
